export const excelStyles = {
  managerClientCellStyle: {
    fontSize: 9.5,
  },
  projectCellStyle: {
    fontSize: 9.5,
  },
  employeeCellStyle: {
    horizontalAlign: "left",
  },
};
